module.exports = __webpack_public_path__ + "img/case_bottom_001.3d6d97f3.png";